import React, { type FC, type PropsWithChildren } from 'react';

type ArrowRightThinProps = {
  /** The color of the icon. */
  color?: string;
};

const ArrowRightThin: FC<PropsWithChildren<ArrowRightThinProps>> = ({ color = 'currentcolor' }) => (
  <svg height="100%" viewBox="0 0 19 15" width="100%" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1 7H0.5V8H1V7ZM18 8H18.5V7H18V8ZM18.5 7H19V6.77003L18.8254 6.62037L18.5 7ZM18.5 8L18.8254 8.37963L19 8.22997V8H18.5ZM1 8H18V7H1V8ZM18.8254 6.62037L11.8254 0.620372L11.1746 1.37963L18.1746 7.37963L18.8254 6.62037ZM18.1746 7.62037L11.1746 13.6204L11.8254 14.3796L18.8254 8.37963L18.1746 7.62037ZM18 7V8H19V7H18Z"
      fill={color}
    />
  </svg>
);

export default ArrowRightThin;
